<template>
  <div>
    <div class="container-fluid">
      <div class="row page-titles">
        <div class="col-md-5 col-8 align-self-center">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/home">Home</router-link>
            </li>
            <li class="breadcrumb-item active">申し送りテンプレート一覧</li>
          </ol>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="dataTables_wrapper dt-bootstrap no-footer">
                <div class="row">
                  <div class="col-1">
                    <div class="p-xl-3">
                      <button type="submit" class="btn btn-success btn-circle" :disabled="isProcessing"
                              @click="search">
                        <i class="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                  <div class="col-4"></div>
                  <div class="col-3">
                    <div class="data-actions">
                      <router-link to="/instruction_new" class="btn btn-rounded btn-outline-info">
                        <i class="fa fa-plus"></i>新規登録する
                      </router-link>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="page">
                  <div class="col-sm-12">
                    <div class="table-responsive" v-if="page.data.length > 0">
                      <table id="myTable" class="table table-sm table-bordered">
                        <thead>
                        <tr>
                          <th>テンプレート名</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="template in page.data" :key="template.id">
                          <td>
                            <router-link :to="`/instruction/${template.id}`">{{template.display_name}}</router-link>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else>
                      <div class="alert alert-warning">
                        <p><i class="fa fa-info-circle p-r-10"/>該当するデータが見つかりませんでした。</p>

                        <p>検索のヒント</p>
                        <ul>
                          <li>
                            検索条件を変更してみてください。
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <pagination :page="page" v-if="page && page.data.length > 0" @change="changePage"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import api from '../../libs/Api'
import constants from '../../constants'
import Pagination from '../../components/Pagination.vue'
import { useExecutor } from '@/libs/Executor'

const { exec } = useExecutor()
const page = ref(null)
const isProcessing = ref(false)

const changePage = (pageNum) => {
  search(pageNum)
}

const search = async (pageNum = 1) => {
  exec(async () => {
    isProcessing.value = true
    const response = await api.getInstructionTemplate(constants.QUERY_MODE_PAGING, pageNum)
    page.value = response
  }).catch((error) => {
    console.error('Error fetching instruction templates:', error)
  }).finally(() => {
    isProcessing.value = false
  })
}

onMounted(() => {
  search()
})
</script>

<style lang="scss" scoped>
.data-actions {
  text-align: right;
}
</style>
